import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=0fc150fa&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=0fc150fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc150fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0fc150fa')) {
      api.createRecord('0fc150fa', component.options)
    } else {
      api.reload('0fc150fa', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=0fc150fa&scoped=true&", function () {
      api.rerender('0fc150fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MMC5XdlihNg5/JS/comp/Voucher.vue"
export default component.exports